function WindowSizeFunction() {
  // would be more performant with an IntersectionObserver

  var navbar = document.getElementById('navbar')

  window.onscroll = function () {
    if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
      navbar.classList.add('sticky')
    } else {
      navbar.classList.remove('sticky')
    }
  }

  // init
  window.onscroll()
}

WindowSizeFunction()

